import { DeleteFilled, EditOutlined, EyeFilled } from "@ant-design/icons";
import { Button, Col, Pagination, Row, Space, Table,Card,List,Typography,Input  } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotFound from "../../../../components/common/notFound";
import ConfirmModal from "../../../../components/modal/confirmModal";
import FailModal from "../../../../components/modal/failModal";
import SuccessModal from "../../../../components/modal/successModal";
import Logo from "../../../../assets/images/ieat_logo.png";
import {
  DATA_MASTER_DATA_TYPE,
  INDUSTRY,
  INDUSTRY_TYPE,
  REGION_GROUP,
  SUCCESS_CODE,
  WORK_PERIOD,
  COMPANY_TYPE,
  VOC_MASTER_DATA_TYPE,
  PRODUCT_REQUIREMENT,
  OTHER_PRODUCT_EXPECT,
  SUPPORT_REQUIREMENT,
  CUSTOMER_SUPPORT,
  OTHER_SUPPORT_EXPECT,
  BUSINESS_REQUIRE,
  OTHER_BUSINESS_EXPECT,
  CUSTOMER_EXPECT,
  CURRENT_CUSTOMER_INDUSTRY_TYPE,
} from "../../../../lib/const";
import useEState from "../../../../lib/hooks/useEState";
import useLineOfWork from "../../../../lib/hooks/useLineOfWork";
import useMasterData from "../../../../lib/hooks/useMasterData";
import useCountry from "../../../../lib/hooks/useCountry";
import useStaffName from "../../../../lib/hooks/useStaffName";

import { routes } from "../../../../routes";
import {
  
  searchCurrentCustomersEstateDbd,
  getCurrentCustomerByEstateDbd
} from "../../../../services/customerCurrent";
import { SearchCustomerPersonaContext } from "../searchContext";
import "../style.css";
import TextArea from "antd/es/input/TextArea";
 


const Content = ({ roleUser }) => {
  const navigate = useNavigate();
  const {
    searchValues,
    setSearchValues,
    pageValues,
    setPageValues,
    search,
    setSearch,
  } = useContext(SearchCustomerPersonaContext);
  const [lineOfWork] = useLineOfWork();
  const [estate] = useEState();
  const [staffName] = useStaffName();
  const [regionGroup] = useMasterData(DATA_MASTER_DATA_TYPE, REGION_GROUP);
  const [workPeriod] = useMasterData(DATA_MASTER_DATA_TYPE, WORK_PERIOD);
  const [industryType] = useMasterData(DATA_MASTER_DATA_TYPE, INDUSTRY_TYPE);
  const [curIndustryType] = useMasterData(DATA_MASTER_DATA_TYPE, CURRENT_CUSTOMER_INDUSTRY_TYPE);
  const [industries] = useMasterData("", INDUSTRY);
  const [companyType] = useMasterData(DATA_MASTER_DATA_TYPE, COMPANY_TYPE);
  let [no, setNo] = useState(0);
  // const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [confirmModal, setConfirmModal] = useState({
    id: 0,
    show: false,
    type: "",
  });
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [countries] = useCountry();

  const [productAndServiceWant] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    PRODUCT_REQUIREMENT
  );
  const [productAndServiceExpected] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_PRODUCT_EXPECT
  );

  const [supportWant] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    CUSTOMER_SUPPORT
  );
  const [supportExpected] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_SUPPORT_EXPECT
  );

  const [transactionWant] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    BUSINESS_REQUIRE
  );
  const [transactionExpected] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    OTHER_BUSINESS_EXPECT
  );  
  const [crmExpected] = useMasterData(
    VOC_MASTER_DATA_TYPE,
    CUSTOMER_EXPECT
  );   
  const months = [
    {
      value: 1,
      name: "ตุลาคม",
    },
    {
      value: 2,
      name: "พฤศจิกายน",
    },
    {
      value: 3,
      name: "ธันวาคม",
    },
    {
      value: 4,
      name: "มกราคม",
    },
    {
      value: 5,
      name: "กุมภาพันธ์",
    },
    {
      value: 6,
      name: "มีนาคม",
    },
    {
      value: 7,
      name: "เมษายน",
    },
    {
      value: 8,
      name: "พฤษภาคม",
    },
    {
      value: 9,
      name: "มิถุนายน",
    },
    {
      value: 10,
      name: "กรกฎาคม",
    },
    {
      value: 11,
      name: "สิงหาคม",
    },
    {
      value: 12,
      name: "กันยายน",
    },
  ];
  //console.log(lineOfWork);
 // console.log(staffName);

  const fetchCurrentCustomers = useCallback(
    async (searchValues, pageValues) => {
      const res = await searchCurrentCustomersEstateDbd(searchValues, pageValues);
      var { objectValue, pageValue } = res.data;

     

      const res_detail =  await getCurrentCustomerByEstateDbd(objectValue[0].dbdRegisterNumber,objectValue[0].estateId);
      console.log(res);
      console.log(res_detail);
      objectValue[0].objCustDetails = res_detail.data.objectValue;
     // console.log("M=====>");
     //  console.log(objectValue);
     // console.log("D=====>");
     //  console.log(objectValue[0].objCustDetails);
     //  console.log("END_D=====>");
     // objectValue[0].objCustDetails.summaryVistor[0].productAndServiceWant
      





      if (res?.data?.code === SUCCESS_CODE) {
        let _p =
          parseInt(pageValues.page) === 0
            ? parseInt(pageValues.page)
            : parseInt(pageValues.page) * pageValues.pageSize;
        setNo(_p);
        setDataSource(objectValue);
        // setSearchValues(objectValue);
        setPageValues(pageValue);
      } else {
        setDataSource([]);
        setPageValues((prev) => ({
          ...prev,
          page: 0,
          pageSize: 1,
          total: 0,
          totalPage: 0,
        }));
      }
    },
    [setDataSource, setSearchValues, setPageValues]
  );

  useEffect(() => {
    if (search) {
      fetchCurrentCustomers(searchValues, pageValues);
      setSearch(false);
    }
  }, [fetchCurrentCustomers, search]);

  const columns = [
    {
      align: "center",
      title: "ลำดับ",
      dataIndex: "no",
      render: () => <span>{(no += 1)}</span>,
    },
    {
      title: "สายงาน",
      dataIndex: "lineOfWorkId",
      key: "lineOfWorkId",
      sorter: (a, b) => a.lineOfWorkId - b.lineOfWorkId,
      render: (_, record) => (
        <span>
          {lineOfWork &&
            lineOfWork.map((e) =>
              e.lineOfWork === record.lineOfWorkId ? e.nameTh : ""
            )}
        </span>
      ),
    },
    {
      title: "นิคมอุตสาหกรรม",
      dataIndex: "estateName",
      key: "estateName",
      sorter: (a, b) => a.estateName - b.estateName,
      render: (_, record) => {
        const arr = record.estateName.split(",");
        return (
          <>
            {arr?.length > 0
              ? arr?.map((item, index) =>
                  estate.map((e) =>
                    e.estateId === item ? (
                      <div>
                        {e.estateNameTh}
                        {index + 1 !== arr?.length && ", "}
                      </div>
                    ) : (
                      ""
                    )
                  )
                )
              : "-"}
          </>
        );
      },
    },
    {
      title: "ชื่อสถานประกอบการ/ชื่อโรงงาน xxx est",
      dataIndex: "factoryNameEn",
      key: "factoryNameEn",
      sorter: (a, b) => a.factoryNameEn - b.factoryNameEn,
      render: (_, record) => (
        <>
          <div>{record.factoryNameTh}</div>
          <div style={{ color: "#82858E" }}>{record.factoryNameEn}</div>
        </>
      ),
    },
    {
      title: "กลุ่มลูกค้าตาม ระยะเวลา ",
      dataIndex: "customerGroupByAge",
      key: "customerGroupByAge",
      sorter: (a, b) => a.customerGroupByAge - b.customerGroupByAge,
      render: (_, record) => (
        <span>
          {workPeriod &&
            workPeriod.map((e) => {
              return e.dataId === record.customerGroupByAge
                ? e.dataDetailTh
                : "";
            })}
        </span>
      ),
    },
    {
      title: "กลุ่มลูกค้าตามสัญชาติ",
      dataIndex: "customerGroupByRegion",
      key: "customerGroupByRegion",
      sorter: (a, b) => a.customerGroupByRegion - b.customerGroupByRegion,
      render: (_, record) => {
        const arr = record.customerGroupByRegion.split(",");
        return (
          <>
            {arr?.length > 0
              ? arr?.map((item, index) =>
                  regionGroup.map((e) =>
                    e.dataId === item ? (
                      <div>
                        {e.dataDetailTh}
                        {index + 1 !== arr?.length && ", "}
                      </div>
                    ) : (
                      ""
                    )
                  )
                )
              : "-"}
          </>
        );
      },
    },
    {
      title: "ประเภทอุตสาหกรรม",
      dataIndex: "typeOfEstate",
      key: "typeOfEstate",
      sorter: (a, b) => a.typeOfEstate - b.typeOfEstate,
      render: (_, record) => {
        return (
          <span>
            {industries &&
              industries.map((e) =>
                e.industryId === record.typeOfEstate ? e.industryNameTh : ""
              )}
          </span>
        );
      },
    },
    {
      title: "คำสั่ง",
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space>
          {!roleUser[0]?.isEdit &&
            !roleUser[0].isDelete &&
            roleUser[0]?.isView && (
              <Button
                className="btn-view"
                shape="circle"
                icon={<EyeFilled style={{ color: "#2e90fa" }} />}
                onClick={() =>
                  navigate(
                    routes.view_customer_current +
                      "/" +
                      record.currentCustomerId
                  )
                }
              />
            )}

          {roleUser[0]?.isEdit && (
            <Button
              className="btn-edit"
              shape="circle"
              icon={<EditOutlined style={{ color: "#F79009" }} />}
              onClick={() =>
                navigate(
                  routes.view_customer_current + "/" + record.currentCustomerId
                )
              }
            />
          )}

          {roleUser[0]?.isDelete && (
            <Button
              className="btn-delete"
              shape="circle"
              icon={<DeleteFilled style={{ color: "#F04438" }} />}
              onClick={() => {
                setConfirmModal({
                  type: "delete",
                  show: true,
                  id: record.currentCustomerId,
                });
              }}
            />
          )}
        </Space>
      ),
    },
  ];

   

  
  const onPageChange = (page, pageSize) => {
    setNo(no + pageSize);
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      page: page - 1,
      pageSize: pageSize,
    }));
  };

  return (
    <div style={{ marginTop: 20 }}>
      <p style={{ margin: "30px 0 10px 0", fontWeight: 500 }}>
        รายการทั้งหมด{" "}
        <span className="pr-purple" style={{ fontWeight: 700 }}>
          {pageValues.total}
        </span>{" "}
        รายการ
      </p>

      <Row gutter={[16, 16]}>
        <Col span={24}>
           <div className="gutter-box">
           <List
            id={"LIST_CUSTOMER"}
            locale={{ emptyText: <NotFound /> }}
            // loading={loading}
          
            dataSource={dataSource}
            columns={columns}
            backgroud-color={"#ff0000"}
            scroll={{
              x: 1300,
            }}
            pagination={false}
            renderItem={(item, index) => (
                <List.Item 
                 id={"LIST_CUSTOMER_ITEM"}
                  className={"gutter-box"}
                  // actions={[<a key="list-loadmore-edit">edit</a>, <a key="list-loadmore-more">more</a>]}
                  
                > { 
                  //console.log(item)
                  }
                 <Row>
                 <Col span={4}></Col><Col span={16}><br/><div  className="text-white-head-center"> Customer Persona (กลุ่มลูกค้าปัจจุบันแยกตามนิคม)</div><br/><br/></Col><Col span={4}><img src={Logo} height={50} alt="I-EA-T LOGO" /></Col>
                </Row>
                <Row>
                    <Col span={4}><div className="text-white-title">DBD Register Number</div><Input className="report-input" value={item.objCustDetails.dbdRegisterNumber} /></Col>
                    <Col span={4}><div className="text-white-title">ชื่อสถานประกอบการ/ชื่อโรงงาน (TH)</div><Input  className="report-input"  value={item.factoryNameTh} /></Col>
                    <Col span={4}><div className="text-white-title">ชื่อสถานประกอบการ/ชื่อโรงงาน (EN)</div><Input  className="report-input"  value={item.factoryNameEn} /></Col>
                    <Col span={4}><div className="text-white-title">สายงาน</div><Input  className="report-input"  value={lineOfWork &&
            lineOfWork.map(function(objItem, i){
              return  objItem.lineOfWork===item.objCustDetails.lineOfWorkId ? objItem.nameTh : "";
            }).toString().replace(/,/g, '')
           
            } /></Col>
                    <Col span={4}><div className="text-white-title">นิคมอุตสาหกรรม/ท่าเรืออุตสาหกรรม</div><Input  className="report-input"  value={estate &&
            
            estate.map(function(objItem, i){
              if(item.objCustDetails.estateNameEn.length==0){return "";}
              return  objItem.estateId===item.objCustDetails.estateNameEn[0] ? objItem.estateNameTh : "";
            }).toString().replace(/,/g, '')
             
              }/></Col>
                    {/* <Col span={4}>
                      <div className="text-white-title">นิคมอุตสาหกรรม/ท่าเรืออุตสาหกรรม</div>
                      <Input
                        className="report-input"
                        readOnly
                        value={
                          estate &&
                          item.objCustDetails.estateNameEn.length > 0 &&
                          item.objCustDetails.estateNameEn
                            .map(function (id) {
                              return estate.find(function (objItem) {
                                return objItem.estateId === id;
                              })?.estateNameTh || "";
                            })
                            .filter(function (name) {
                              return name !== "";
                            })
                            .toString()
                            .replace(/,/g, ', ')
                        }
                      />
                    </Col> */}
                    <Col span={4}><div className="text-white-title">ประเภทกิจการ</div><Input  className="report-input"  value={
                      companyType &&
                      companyType.map(function(objItem, i){
              return  objItem.dataId===item.objCustDetails.typeOfBusiness ? objItem.dataDetailTh : "";
            }).toString().replace(/,/g, '')
           
            }  /></Col>
                </Row>
                <Row>
                    <Col span={8}><div className="text-white-title">กลุ่มลูกค้าตามอายุ</div><Input className="report-input" value={workPeriod &&
            
            workPeriod.map(function(objItem, i){
              return  objItem.dataId===item.objCustDetails.customerGroupByAge ? objItem.dataDetailTh : "";
            }).toString().replace(/,/g, '')
           
            } /></Col>
                    <Col span={8}><div className="text-white-title">กลุ่มลูกค้าตามสัญชาติ</div><Input  className="report-input" value={regionGroup &&
            
            regionGroup.map(function(objItem, i){
              return  objItem.dataId===item.customerGroupByRegion ? objItem.dataDetailTh : "";
            }).toString().replace(/,/g, '')
           
            } /></Col>
                    <Col span={3}><div className="text-white-title">สัญชาติลูกค้า (ประเทศ)</div><Input  className="report-input"   value={regionGroup &&
            
            countries.map(function(objItem, i){
              return  objItem.countryId===item.objCustDetails.customerRegion[0] ? objItem.countryNameTh : "";
            }).toString().replace(/,/g, '')
           
            } /></Col>  
                    <Col span={3}><div className="text-white-title">ลูกค้าตามกลุ่มอุตสาหกรรม</div><Input  className="report-input"   value={regionGroup &&
            
            industryType.map(function(objItem, i){
              return  objItem.dataId===item.objCustDetails.customerGroupByEstateType ? objItem.dataDetailTh : "";
            }).toString().replace(/,/g, '')
           
            } /></Col>
                    <Col span={2}><div className="text-white-title">ประเภทอุตสาหกรรม</div><Input  className="report-input"  value={regionGroup &&
            
            industries.map(function(objItem, i){
              return  objItem.industryId===item.objCustDetails.typeOfEstate ? objItem.industryNameTh : "";
            }).toString().replace(/,/g, '')
           
            } /></Col>
                </Row>
                <Row>
                    <Col span={24}><br/><div  className="text-white-head">ข้อมูลการเข้าเยี่ยมลูกค้า</div><br/></Col>
                </Row>
                <Row> 
                    <Col span={4}><div className="text-white-title">นิคมอุตสาหกรรม/ท่าเรืออุตสาหกรรม</div><Input className="report-input" value={estate &&
               estate.map(function(objItem, i){
                if(item.objCustDetails.estateNameEn.length==0){return "";}
                return  objItem.estateId===item.objCustDetails.estateNameEn[0] ? objItem.estateNameTh : "";
              }).toString().replace(/,/g, '')
            // estate.map(function(objItem, i){
            //   if(!item.objCustDetails.summaryVisitor.length==0){ return "";};
            //   return  objItem.estateId===item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].summaryEstateId[0] ? objItem.estateNameTh : "";
            // }).toString().replace(/,/g, '')
           
            } /></Col>

                    <Col span={3}><div className="text-white-title">ปีงบประมาณ</div><Input  className="report-input"  value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].yearOfBudget} /></Col>
                    <Col span={2}><div className="text-white-title">เดือน</div><Input  className="report-input"  value={item.objCustDetails.summaryVisitor && 
                        months.map(function(objItem, i){
                          if(item.objCustDetails.summaryVisitor.length==0){return "";}
                          return objItem.value==item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].monthOfBudget? objItem.name: "";
                        }).toString().replace(/,/g, '')
                      } /></Col>
            {/* <Col span={3}><div className="text-white-title">ชื่อเจ้าหน้าที่เข้าเยี่ยมลูกค้า</div><Input  className="report-input"  value={useStaffName &&
            
            staffName.map(function(objItem, i){
              if(item.objCustDetails.summaryVisitor.length==0){return "";}
              return  objItem.id===item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].staffName[0] ? objItem.value : "";
            }).toString().replace(/,/g, '')
           
            } />
            </Col> */}
            {/* <Col span={3}><div className="text-white-title">ชื่อ-นามสกุล</div><Input  className="report-input"  value={useStaffName &&
            
            staffName.map(function(objItem, i){
              if(item.objCustDetails.summaryVisitor.length==0){return "";}
              return  objItem.id===item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].staffName[0] ? objItem.value : "";
            }).toString().replace(/,/g, '')
           
            }  />
            </Col> */}
                    {/* <Col span={3}><div className="text-white-title">ชื่อ-นามสกุล ผู้จัดทำรายงาน</div><Input  className="report-input"   value={useStaffName &&
            
            staffName.map(function(objItem, i){
              if(item.objCustDetails.summaryVisitor.length==0){return "";}
              return  objItem.id===item.objCustDetails.summaryVisitor[item.objCustDetails?.summaryVisitor?.length-1]?.reporterName[0] ? objItem.value : "";
            }).toString().replace(/,/g, '')
           
            }  /></Col> */}
                    {/* <Col span={3}><div className="text-white-title">ตำแหน่งผู้จัดทำรายงาน</div><Input  className="report-input"  value={useStaffName &&
            
            staffName.map(function(objItem, i){
              if(item.objCustDetails.summaryVisitor.length==0){return "";}
              return  objItem.id===item.objCustDetails.summaryVisitor[item.objCustDetails?.summaryVisitor?.length-1]?.reporterName[0] ? objItem.position : "";
            }).toString().replace(/,/g, '')
           
            }  /></Col> */}
                    {/* <Col span={3}><div className="text-white-title">เบอร์โทรผู้จัดทำรายงาน</div><Input  className="report-input"  value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].reporterPhoneNumber} /></Col> */}
                </Row>
                {/* <Row>
                    <Col span={6}><div className="text-white-title">E-mail ผู้จัดทำรายงาน</div><Input className="report-input" value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].reporterEmail} /></Col>
                </Row> */}
                {/* <Row>
                    <Col span={24}><br/><div  className="text-white-head">ข้อมูลลูกค้า</div><br/></Col>
                </Row>
                <Row>
                    <Col span={4}><div className="text-white-title">ขนาดพื้นที่(ไร่)</div><Input className="report-input" value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].areaSizeByRai}/></Col>
                    <Col span={4}><div className="text-white-title">ขนาดพื้นที่ (งาน)</div><Input  className="report-input"  value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].areaSizeByNgan} /></Col>
                    <Col span={3}><div className="text-white-title">ขนาดพื้นที่ (ตรม.)</div><Input  className="report-input"  value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].areaSizeByMeters}/></Col>
                    <Col span={4}><div className="text-white-title">ปริมาณการใช้น้ำต่อเดือน (ลบ.ม.)</div><Input  className="report-input"  value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].waterConsumption} /></Col>
                    <Col span={3}><div className="text-white-title">จำนวนคนงาน</div><Input  className="report-input"  value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].numberOfWorker} /></Col>
                </Row>
                <Row>
                    <Col span={4}><div className="text-white-title">ตำแหน่งผู้บริหารโรงงานที่เข้าพบ</div><Input className="report-input" value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].ceoPositionOfFactory} /></Col>
                    <Col span={4}><div className="text-white-title">ชื่อผู้บริหารโรงงานที่เข้าพบ</div><Input  className="report-input"  value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].ceoNameOfFactory} /></Col>
                    <Col span={4}><div className="text-white-title">ชื่อผู้ติดต่อ/ผู้ประสานงาน</div><Input  className="report-input"  value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].coordinatorName} /></Col>
                    <Col span={4}><div className="text-white-title">อีเมล์ผู้ติดต่อ/ผู้ประสานงาน</div><Input  className="report-input"  value={item.objCustDetails.summaryVisitor.length==0?"":item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].coordinatorEmail} /></Col>
                    
                </Row> */}
                <Row>
                    <Col span={12}><br/><div  className="text-white-head">ด้านผลิตภัณฑ์และบริการ</div><br/>
                    {
                     // item.objCustDetails.summaryVisitor.length ;
                    }
                      <div  className="card bg-light shadow-sm">
                        <div className="card-body card-scroll h-200px div_scroll" >
                         1. ลูกค้ามีความต้องการด้านผลิตภัณฑ์และบริการของ กนอ. อย่างไร<br/>
                         {item.objCustDetails.summaryVisitor?.map((objItem) =>
                            objItem.productAndServiceWant?.length
                              ? ` - ${objItem.productAndServiceWant[0]}`  // แสดงค่าตัวแรกตามพฤติกรรมเดิม
                              : ''
                          ).join('')}
                          <br/>

                        2. ลูกค้ามีความคาดหวังที่นอกเหนือต้องการด้านผลิตภัณฑ์และบริการของ กนอ. อย่างไร<br/>
                        {item.objCustDetails.summaryVisitor?.map((objItem) =>
                            objItem.productAndServiceExpected?.length
                              ? ` - ${objItem.productAndServiceExpected[0]}`  // แสดงค่าตัวแรกตามพฤติกรรมเดิม
                              : ''
                          ).join('')}
                          <br/>
                        {/* {item.objCustDetails.summaryVisitor && item.objCustDetails.summaryVisitor.map(function(objItem, i){
                          //if(item.objCustDetails.summaryVisitor.length==0){return "";}
                            if(objItem.productAndServiceExpected.length==0) return;
                          return  ' - '+ productAndServiceExpected.map(function(masItem,j){
                           
                              //console.log("b="+objItem.productAndServiceWant.length);
                              if(masItem.vocUniqueId===objItem.productAndServiceExpected[0]){
                                //console.log("found="+masItem.vocDetailTh);
                                return masItem.vocDetailTh;
                              }
                          })
                           
                         }).toString().replace(/,/g, '') 
                        
                         } <br/> */}
                        </div>
                      </div>
                    </Col>
                    <Col span={12}><br/><div  className="text-white-head">ด้านการสนับสนุนลูกค้า</div><br/>
                    <div  className="card bg-light shadow-sm">
                        <div className="card-body card-scroll h-200px div_scroll" >
                         1. ลูกค้ามีความต้องการด้านการสนับสนุนของ กนอ. อย่างไร<br/>
                         {item.objCustDetails.summaryVisitor?.map((objItem) =>
                            objItem.productAndServiceWant?.length
                              ? ` - ${objItem.productAndServiceWant[0]}`  // แสดงค่าตัวแรกตามพฤติกรรมเดิม
                              : ''
                          ).join('')}
                          <br/>
                         {/* {item.objCustDetails.summaryVisitor && item.objCustDetails.summaryVisitor.map(function(objItem, i){
                          //if(item.objCustDetails.summaryVisitor.length==0){return "";}
                            if(objItem.supportWant.length==0) return;
                          return  ' - '+ supportWant.map(function(masItem,j){
                           
                              //console.log("b="+objItem.productAndServiceWant.length);
                              if(masItem.vocUniqueId===objItem.supportWant[0]){
                                //console.log("found="+masItem.vocDetailTh);
                                return masItem.vocDetailTh;
                              }
                          })
                           
                         }).toString().replace(/,/g, '') 
                        
                         } <br/> */}

                        2. ลูกค้ามีความคาดหวังด้านการสนับสนุนของ กนอ. อย่างไร<br/>
                        {item.objCustDetails.summaryVisitor?.map((objItem) =>
                            objItem.supportExpected?.length
                              ? ` - ${objItem.supportExpected[0]}` 
                              : ''
                          ).join('')}
                          <br/>
                        {/* {item.objCustDetails.summaryVisitor && item.objCustDetails.summaryVisitor.map(function(objItem, i){
                          //if(item.objCustDetails.summaryVisitor.length==0){return "";}
                            if(objItem.supportExpected.length==0) return;
                          return  ' - '+ supportExpected.map(function(masItem,j){
                           
                              //console.log("b="+objItem.productAndServiceWant.length);
                              if(masItem.vocUniqueId===objItem.supportExpected[0]){
                                //console.log("found="+masItem.vocDetailTh);
                                return masItem.vocDetailTh;
                              }
                          })
                           
                         }).toString().replace(/,/g, '') 
                        
                         } <br/> */}
                        </div>
                      </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}><br/><div  className="text-white-head">ด้านการทำธุรกรรม</div><br/>
                    <div  className="card bg-light shadow-sm">
                        <div className="card-body card-scroll h-200px div_scroll" >
                         1. ลูกค้ามีความต้องการการทำธุรกรรมของ กนอ. อย่างไร<br/>
                         {item.objCustDetails.summaryVisitor?.map((objItem) =>
                            objItem.transactionWant?.length
                              ? ` - ${objItem.transactionWant[0]}` 
                              : ''
                          ).join('')}
                          <br/>
                         {/* {item.objCustDetails.summaryVisitor && item.objCustDetails.summaryVisitor.map(function(objItem, i){
                          //if(item.objCustDetails.summaryVisitor.length==0){return "";}
                            if(objItem.transactionWant.length==0) return;
                          return  ' - '+ transactionWant.map(function(masItem,j){
                           
                              //console.log("b="+objItem.productAndServiceWant.length);
                              if(masItem.vocUniqueId===objItem.transactionWant[0]){
                                //console.log("found="+masItem.vocDetailTh);
                                return masItem.vocDetailTh;
                              }
                          })
                           
                         }).toString().replace(/,/g, '') 
                        
                         } <br/> */}

                        2. ลูกค้ามีความคาดหวังด้านการทำธุรกรรมของ กนอ. อย่างไร<br/>
                        {item.objCustDetails.summaryVisitor?.map((objItem) =>
                            objItem.transactionExpected?.length
                              ? ` - ${objItem.transactionExpected[0]}` 
                              : ''
                          ).join('')}
                          <br/>
                        {/* {item.objCustDetails.summaryVisitor && item.objCustDetails.summaryVisitor.map(function(objItem, i){
                          //if(item.objCustDetails.summaryVisitor.length==0){return "";}
                            if(objItem.transactionExpected.length==0) return;
                          return  ' - '+ transactionExpected.map(function(masItem,j){
                           
                              //console.log("b="+objItem.productAndServiceWant.length);
                              if(masItem.vocUniqueId===objItem.transactionExpected[0]){
                                //console.log("found="+masItem.vocDetailTh);
                                return masItem.vocDetailTh;
                              }
                          })
                           
                         }).toString().replace(/,/g, '') 
                        
                         } <br/> */}
                        </div>
                      </div>
                    </Col>
                    <Col span={12}><br/><div  className="text-white-head">ด้านการจัดการความสัมพันธ์ (CRM)</div><br/>
                    <div  className="card bg-light shadow-sm">
                        <div className="card-body card-scroll h-200px div_scroll" >
                         1. ลูกค้ามีความต้องการด้านการจัดการความสัมพันธ์ (CRM) กนอ. อย่างไร<br/>
                         {item.objCustDetails.summaryVisitor?.map((objItem) =>
                            objItem.crmExpected?.length
                              ? ` - ${objItem.crmExpected[0]}` 
                              : ''
                          ).join('')}
                          <br/>
                         {/* {item.objCustDetails.summaryVisitor && item.objCustDetails.summaryVisitor.map(function(objItem, i){
                          //if(item.objCustDetails.summaryVisitor.length==0){return "";}
                            if(objItem.transactionExpected.length==0) return;
                          return  ' - '+ crmExpected.map(function(masItem,j){
                           
                              //console.log("b="+objItem.productAndServiceWant.length);
                              if(masItem.vocUniqueId===objItem.crmExpected[0]){
                                //console.log("found="+masItem.vocDetailTh);
                                return masItem.vocDetailTh;
                              }
                          })
                           
                         }).toString().replace(/,/g, '') 
                        
                         } <br/> */}

                         
                        </div>
                      </div>
                    </Col>
                </Row>
                <Row>
                <Col span={24}><br/><div  className="text-white-head">Pain Point</div><br/>
                    <div  className="card bg-light shadow-sm">
                        <div className="card-body card-scroll h-200px div_scroll" >
                        {item.objCustDetails.summaryVisitor.length>0 &&  (() => {
                            return  ' - '+ item.objCustDetails.summaryVisitor[item.objCustDetails.summaryVisitor.length-1].notSatisfied
                            })()
                         } <br/>

                          
                        </div>
                      </div>
                    </Col>
                </Row>
                

                </List.Item>
              )}
            />
            
            </div>
        </Col>
        <Col span={24} align="right">
          <Pagination
            showSizeChanger
            defaultCurrent={pageValues.page + 1 || 1}
            total={pageValues.total || 1}
            onChange={onPageChange}
            pageSize={1}
            pageSizeOptions={[1,10, 20, 50, 100]}
            showTotal={(total) => `รวม ${total} รายการ`}
          />
        </Col>
      </Row>

     
 
    </div>
  );
};



export default Content;
